module.exports = __webpack_public_path__ + "img/slide_patinete.30860685.jpg";